import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import { connect } from 'react-redux';
import T from 'aegisv2/Text';
import ArrowLeft from 'crehana-icons/ArrowLeft';
import ContentWrapper from 'Catalog/ui/ContentWrapper';
import { secondaryMain } from 'crehana-ui/styles/colors';
import STRINGS from 'Catalog/strings';

import {
  COURSES_PAGE_SIZE,
  formatCourseV2,
  checkIfisInShoppingCart,
} from 'Catalog/utils';
import GroupTitle from 'Catalog/ui/GroupTitle';
import {
  getCategorySelected,
  getLevelsSelected,
  getSoftwaresSelected,
} from 'Jsx/Catalog/components/FiltersV2/redux/selectors';

import {
  toggleFilterCategory,
  toggleFilterLevel,
  toggleFilterSoftware,
  clearAllFilters,
  disableSoftwaresAndLevels,
  showAllCourses,
} from 'Jsx/Catalog/components/FiltersV2/redux/actions';

import CourseRecommended from 'Jsx/Catalog/components/CourseRecommended';

import GET_RECOMMENDED_FOR_ME_QUERY from 'Jsx/Catalog/graphql/getRecommendedForMe.graphql';
import CourseList from '../../containers/CourseList';

import {
  getCurrentPage,
  getTotalPages,
  setCurrentPage,
  setTotalPages,
} from '../../Pagination/ducks';

import Pagination from '../../Pagination';

import {
  PaginationWrapper,
  ContentTopWrapper,
  ScrollTopWrapper,
  ScrollTopIconWrapper,
  // SubTitle,
  EmptySubTitle,
  // StyledPagination,
  ResultsTitle,
  Title,
} from './styles';

const ClearFilterButton = styled.button`
  display: none;
  @media (min-width: 768px) {
    display: inline-block;
    margin-bottom: 10px;
    outline: none;
  }
`;

class ResultsV2 extends Component {
  state = {
    loading: false,
  };

  showAllCourses = e => {
    e.preventDefault();
    const {
      allCourses,
      scrollTop,
      showAllCourses: showAllCoursesActions,
      setDefaultOrderBy: setDefaultOrderByAction,
      clearAllFilters: clearAllFiltersAction,
      orderBySelected,
      defaultOrderBy,
    } = this.props;

    scrollTop();

    clearAllFiltersAction();

    if (orderBySelected.slug !== defaultOrderBy.slug) {
      setDefaultOrderByAction();
    }

    if (!allCourses) {
      showAllCoursesActions();
    }
  };

  render() {
    const {
      loading,
      totalPages,
      courses,
      courseIdsOwned,
      theme,
      removeCourseFromCart,
      resultTitle,
      scrollTop,
      search,
      addCourseToCart,
      user,
      levelsSelected,
      // subCategoriesSelected,
      softwaresSelected,
      // toggleFilterSubItem,
      isOrganization,
      loadingCartButton,
    } = this.props;

    if (!loading && (!courses || !courses.length)) {
      const emptyTitle = `No hemos encontrado resultados para "${search ||
        resultTitle}"`;

      return (
        <ContentWrapper>
          <GroupTitle>{emptyTitle}</GroupTitle>
          <EmptySubTitle>{STRINGS.results.emptySubTitle}</EmptySubTitle>
          <CourseRecommended
            courseIdsOwned={courseIdsOwned}
            removeCourseFromCart={removeCourseFromCart}
            addCourseToCart={addCourseToCart}
          />
        </ContentWrapper>
      );
    }

    const hasFilterTagsToShow =
      levelsSelected.length > 0 || softwaresSelected.length > 0;

    return (
      <ContentWrapper>
        <ContentTopWrapper
          a="flex-start"
          J="space-between"
          d="row"
          hasSubTitle={false}
        >
          <ResultsTitle d="column" hasFilterTagsToShow={hasFilterTagsToShow}>
            <Title>Mejora otras habilidades</Title>
            {/* {!loading && false ? <SubTitle>{`${courses.length} cursos`}</SubTitle> : null} */}
          </ResultsTitle>
          <ClearFilterButton onClick={this.props.showAllCourses}>
            <T xs bold color={secondaryMain}>
              Mostrar todos los cursos
            </T>
          </ClearFilterButton>
        </ContentTopWrapper>
        <CourseList
          skeletonItems={24}
          courseIdsOwned={courseIdsOwned}
          courses={courses}
          loading={loading}
          isUserLogged={!!user}
          user={user}
          isOrganization={isOrganization}
          loadingCartButton={loadingCartButton}
          itemsPerRow={{
            1680: 4,
            1440: 4,
            1280: 4,
            1024: 3,
            768: 2,
          }}
        />
        {totalPages > 1 && (
          <PaginationWrapper>
            <ScrollTopWrapper a="center" mr="22px" onClick={scrollTop}>
              <ScrollTopIconWrapper>
                <ArrowLeft color={theme.colors.filter} size={7} />
              </ScrollTopIconWrapper>
              <T bold color={secondaryMain}>
                {STRINGS.backToTop}
              </T>
            </ScrollTopWrapper>
            <Pagination loading={loading} totalPages={totalPages} />
          </PaginationWrapper>
        )}
      </ContentWrapper>
    );
  }
}

ResultsV2.propTypes = {
  // enable eslint if it is necessary
  // eslint-disable-next-line react/no-unused-prop-types
  courseIdsOwned: PropTypes.arrayOf(PropTypes.number).isRequired,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      affiliateCommission: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      affiliateUrl: PropTypes.string,
      buyUrl: PropTypes.string,
      discount: PropTypes.number,
      duration: PropTypes.number,
      id: PropTypes.number,
      imagePlaceholder: PropTypes.string,
      inShoppingCart: PropTypes.bool,
      isEnrolled: PropTypes.bool,
      isEnrollment: PropTypes.bool,
      level: PropTypes.shape({
        name: PropTypes.string,
      }),
      originalId: PropTypes.number,
      prices: PropTypes.shape({
        currencySymbol: PropTypes.string,
        price: PropTypes.number,
        realPrice: PropTypes.number,
      }),
      promoImage: PropTypes.string,
      score: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  currentPage: PropTypes.number,
  loading: PropTypes.bool,
  pages: PropTypes.number,
  removeCourseFromCart: PropTypes.func.isRequired,
  addCourseToCart: PropTypes.func.isRequired,
  resultTitle: PropTypes.string.isRequired,
  scrollTop: PropTypes.func.isRequired,
  search: PropTypes.string,
  setCurrentPage: PropTypes.func.isRequired,
  setTotalPages: PropTypes.func.isRequired,

  levelsSelected: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  softwaresSelected: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  // redux actions
  clearAllFilters: PropTypes.func.isRequired,
  showAllCourses: PropTypes.func.isRequired,
  // styled-components theme
  theme: PropTypes.shape({}).isRequired,
  totalPages: PropTypes.number,
  user: PropTypes.shape({}),
  isOrganization: PropTypes.bool,
  loadingCartButton: PropTypes.bool.isRequired,
};

ResultsV2.defaultProps = {
  courses: undefined,
  currentPage: 1,
  loading: false,
  orderBy: '',
  pages: 1,
  search: null,
  softwares: null,
  levels: null,
  totalPages: 1,
  user: null,
  categorySelected: null,
  isOrganization: false,
};

const getCursor = (currentPage, pageSize) => {
  // in SSR return the page 0 in base64 (arrayconnection:0)
  if (typeof window === 'undefined') return 'YXJyYXljb25uZWN0aW9uOjA=';
  return btoa(`arrayconnection:${(currentPage - 1) * pageSize - 1}`);
};

const mapStateToProps = state => {
  const { categorySelected, subCategoriesSelected } = getCategorySelected(
    state,
  );
  const levelsSelected = getLevelsSelected(state);
  const softwaresSelected = getSoftwaresSelected(state);
  const orderBySelected = state.orderBy.itemSelected;

  return {
    // search: getSearch(state),
    orderBy: orderBySelected.value,
    categorySelected,
    subCategoriesSelected,
    levelsSelected,
    softwaresSelected,
    currentPage: getCurrentPage(state),
    pages: getTotalPages(state),
    coursesNoResults: [],
    resultTitle:
      (subCategoriesSelected.length > 0 &&
        `Cursos online de ${subCategoriesSelected[0].name}`) ||
      (categorySelected && `Cursos online de ${categorySelected.name}`) ||
      (softwaresSelected.length > 0 &&
        `Cursos online de ${softwaresSelected
          .map(software => software.name)
          .join(', ')}`) ||
      (levelsSelected.length > 0 &&
        `Cursos online de nivel ${levelsSelected.map(l => l.name).join(', ')}`) ||
      (orderBySelected &&
        orderBySelected.slug === 'online' &&
        'Todos los cursos') ||
      (orderBySelected &&
        orderBySelected.slug === 'ofertas' &&
        `Cursos en ${orderBySelected.value}`) ||
      (orderBySelected && `Cursos ${orderBySelected.value}`),
  };
};

// a simple request id to not send duplicate requests if the component re-render from the parent
let criteoRequestId = '';

const mapResultsToProps = ({ getCourses, ownProps }) => {
  // eslint-disable-line no-shadow, max-len
  const props = {
    loading: getCourses.loading,
    queryVariables: getCourses.variables,
  };

  if (!getCourses.loading && getCourses.courses) {
    const { courses } = getCourses;

    props.totalPages = Math.ceil(courses.totalCount / COURSES_PAGE_SIZE);

    props.queryId = Date.now();
    props.courses = courses.edges
      .map(e => e.node)
      .map(formatCourseV2)
      .map(checkIfisInShoppingCart(ownProps.courseIdsOwned));

    // the query returns what softwares/levels has the current category/subCategory
    props.softwares = getCourses.courses.softwares;
    props.levels = getCourses.courses.levels;

    try {
      // Use the variables of the query to identify the request
      // so we only run the criteo_q.push function once time for each new query
      const currentCriteoRequestId = JSON.stringify(getCourses.variables);

      if (!criteoRequestId || criteoRequestId !== currentCriteoRequestId) {
        criteoRequestId = currentCriteoRequestId;
        const coursesIdsArray = props.courses
          .map(course => course.originalId || course.id)
          .map(courseId => courseId.toString());

        window.criteo_q.push({ event: 'viewList', item: coursesIdsArray });
      }
    } catch (error) {
      console.error(
        'Error to stringify the variables query or to run the criteo function',
        error,
      );
    }
  }

  return props;
};

export default compose(
  connect(mapStateToProps, {
    setCurrentPage,
    setTotalPages,

    toggleFilterLevel,
    toggleFilterSoftware,
    toggleFilterCategory,
    clearAllFilters,
    disableSoftwaresAndLevels,
    showAllCourses,
  }),
  graphql(GET_RECOMMENDED_FOR_ME_QUERY, {
    name: 'getCourses',
    options: ({
      categorySelected,
      subCategoriesSelected,
      currentPage,
      user,
    }) => {
      const subCategoriesSelectedFromFilters = categorySelected
        ? subCategoriesSelected.map(sc => sc.slug).join(',')
        : null;
      const newSubCategories =
        user && user.tastes
          ? user.tastes.map(taste => taste.name).join(',')
          : subCategoriesSelectedFromFilters;

      return {
        variables: {
          pageSize: COURSES_PAGE_SIZE,
          newSubCategories,
          cursor: getCursor(currentPage, COURSES_PAGE_SIZE),
        },
      };
    },
    props: mapResultsToProps,
  }),
  withTheme,
)(ResultsV2);
